
import ConditionalRender from "components/ConditionalRender";

const ModalConfigTable = ({itemsShown, setItem, _TC}) => {

    const onClickRadio = (e) => {
        setItem({...itemsShown[parseInt(e.target.value)]});
    };


    return (
        <ConditionalRender
            condition={itemsShown.length > 0}
            fallback={<div className="alert alert-secondary text-center">{_TC("noData")}</div>}
        >
            <table className="table table-striped">
                <thead>
                <tr>
                    <th style={{width: "32px"}}></th>
                    <th>{_TC("label.name")}</th>
                    <th>{_TC("label.format")}</th>
                    <th>{_TC("label.description")}</th>
                </tr>
                </thead>
                <tbody>
                {itemsShown.map((item, index) => (
                    <tr key={index} data-idx={index}>
                        <td className="align-middle">
                            <input type="radio" name="radio-" value={index} onClick={onClickRadio}/>
                        </td>
                        <td>{item.name}</td>
                        <td>{_TC("format.choice." + item.format)}</td>
                        <td>{item.description}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </ConditionalRender>

    )
}

export default ModalConfigTable

